import styled from "styled-components";

export const Prices = styled.div`
 .teste {
        padding: 10px 0 20px 0px;
        border-radius: 10px;
        box-shadow: 0px 0px 10px rgba(0,0,0,0.25);
    }
    h2{
        font-size: 24px;
        font-weight: 500;
        color: #87868F;
        margin: 25px 0 0 100px;
    }

    h4{
        margin-bottom: 10px;
        color: #403F4C;
        margin-top: 25px;
    }

    .planInfo{
        margin: 0 0 0 100px;
        h3{
            font-size: 20px;
            font-weight: 500;
            color: #004FFF;
            margin: 32px 0 15px 0;
        }

        /** Form **/
        .formulario{
            display: flex;
            justify-content: center;
            flex-direction: column;
            margin: 15px 0 0 0;
            width: 100%;

            label{
                color: #403F4C;
                font-size: 14px;
                font-weight: 500;

                /* &:before{
                    display: none;
                } */
            }

            span{
                color: #87868F;
                font-size: 10px;
                margin-left: 5px;
            }

            input{
                width: 625px;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
                padding-left: 10px;
                margin-bottom: 15px;
            }

            .switch__container{
                margin: 5px 0 15px;
                span{
                    margin-left: 50px;
                }
                span.bestSeller{
                    margin-left: 46%;
                }
            }

            .switch--shadow:checked + label:before {
                background-color: #8ce196;
            }

            .numberClass{
                margin: 5px 0 0 0;
                input{
                    width: 200px;
                }
            }
        }

        .deleteType{
            border: 1px solid #FF5666 !important;
            border-radius: 26px;
            color: #FF5666;
            font-size: 12px;
            font-weight: 500;
            background-color: transparent;
            width: auto !important;
            height: 22px;
            cursor: pointer;
            margin: 0 0 10px 0;

            &:last-child{
                width: 103px;
                margin-top: 20px;
            }

            span{
                color: #FF5666;
                margin-top: 2px !important;
            }
        }

        .deletePlans{
            width: 103px !important;
            height: 22px !important;
            border-radius: 26px;
            background: transparent;
            border: 1px solid #FF5666 !important;
            color: #FF5666 !important;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 25px 0 20px 0;
            font-family: 'Quicksand', sans-serif;
        }

        .lingos{
            h4{
                color: #004FFF;
                font-size: 20px;
                font-weight: 500;
                margin: 30px 0 15px 0;
            }

            .lingoSelects{
                display: flex;
            }

            .linha{
                width: 2px;
                background-color: #707070;
                height: auto;
                opacity: 0.2;
                margin-left: 12px;
            }

            .lineContent{
                display: flex;

                div:nth-child(2) { margin-right: 15px; }
                div:nth-child(3) { margin-right: 15px; }
            }

            .selects{
                display: flex;
                flex-direction: column;
                margin-left: 13px;

                .input-lingo {
                    width: 210px;
                    height: 32px;
                    margin: 0;
                }

                .delet{
                    display: flex;
                    flex-direction: column;

                    .inputDelete{
                        display: flex;
                        flex-direction: column;

                        div {
                            display: flex;
                        }
                    }

                    .delete{
                        color: red;
                        font-size: 12px;
                        font-weight: 500;
                        border: none;
                        margin-bottom: -10px;
                    }

                    .input-lingo{
                        margin-bottom: 10px;
                    }

                }

                .priceSelect{
                    display: flex;
                    flex-direction: column;
                }

                select, input{
                    width: 200px;
                }
            }

             .price{
                .lingoSelects{
                    .wrapperPrice {
                        display: flex;
                        align-items: center;
                        gap: 20px;

                        .title {
                            text-align: left;
                            font-weight: 700;
                            font-size: 15px;
                            color: #403F4C;
                            font-family: 'Quicksand',sans-serif;

                            padding-bottom: 10px;
                        }

                        .linhaPrice{
                            width: 2px;
                            background-color: #707070;
                            height: auto;
                            opacity: 0.2;
                            margin: 0 16px 0 0;
                        }

                        span{
                            text-align: center;
                            font-size: 12px;
                            margin-top: 5px;
                        }

                        .countryCurrency{
                            display: flex;
                            flex-direction: column;
                        }

                        span.currency{
                            text-align: left;
                            margin-left: 20px;
                            margin-top: 0;
                        }
                        label{
                            font-weight: 500;
                            font-size: 14px;
                            color: #403F4C;
                            font-family: 'Quicksand', sans-serif;
                        }

                        button{
                            margin: 10px 0 35px 18px;
                            width: 126px;
                        }

                        .delete {
                            margin-top: 0;
                            margin-bottom: 30px;
                            text-align: left;
                        }
                    }

                    .addCountry{
                        margin: 10px 0 35px 18px;
                        width: 126px;
                    }
                }
            }
        }

        .delete {
            margin: 0 !important;
        }

    }

    .wrapperRow {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 15px;
    }

    .buttons{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
            margin: 25px;
            padding: 0 15px 0 15px;
            cursor: pointer;
            width: 95%;
            max-width: 1300px;

            button{
                background-color: #004FFF;
                border: none;
                color: #fff;
                font-weight: bold;
                font-size: 14px;
                border-radius: 26px;
                padding: 10px 20px;
                height: 38px;
                margin-top: 5px;
                cursor: pointer;
                font-family: 'Quicksand', sans-serif;

                &:first-child{
                    background-color: transparent;
                    border:1px solid #787780;
                    color: #787780;
                    font-weight: bold;
                    font-size: 11px;
                    border-radius: 26px;
                    width: 71px;
                    height: 28px;
                    margin-top: 8px;
                    margin-right: 10px;
                    cursor: pointer;
                    font-family: 'Quicksand',sans-serif;
                    align-items: center;
                    display: flex;
                    justify-content: center;

                    .fa{
                        margin-right: 8px;
                        font-size: 20px;
                    }
                }

            }
    }

`;

export const TableUser = styled.div`
    margin-top: 21px;

    .boxTable{
        display: flex;
        width: 100%;
        padding: 0 12px 0 10px;
        background-color: #fff;
        justify-content: space-between;
        border: 1px solid;
        flex-direction: row;

        .boxItem{
            display: flex;
            justify-content: space-between;
            flex-direction: column;

            h3{
                font-size: 12px;
                color: #403F4C;
                font-weight: bold;
            }

            .itemTop{
                h3{
                    margin: 11px 139px 0 0;
                }
            }

        }
        hr{
            margin-top: 0;
        }
    }


    table{
        width: 100%;
        border-collapse: collapse;
        margin: 15px 0 15px 0;

        tr{
            text-align: left;
            height: 35px;

            th{
                color: #403F4C;
                font-size: 12px;
                font-weight: bold;

                /* &:first-child{
                    width: 55%;
                } */
            }

            :nth-child(2){
                border-top: 1px solid #B2B2B7;
            }
        }

        td {
            border-bottom: 1px solid #B2B2B7;
            height: 33px;
            font-size: 14px;
            color: #403F4C;
            font-weight: 500;
            font-family: 'Work Sans', sans-serif;

            span{
                color: #0ED572;
                font-weight: bold;
            }
            .inativo{
                color: #FF5666;
                font-weight: bold;
            }
            button{
                background-color: transparent;
                border: 1px solid #787780;
                border-radius: 26px;
                color: #787780;
                font-size: 11px;
                width: 58px;
                height: 22px;
                float: right;
                cursor: pointer;
                padding-left: 8px;

                .fa{
                    margin-right: 3px;
                }
            }
        }
    }

`;
